import { getAuthSelfQueryOptions } from '@api/endpoints/auth/get-auth-self'
import { UserProvider } from '@core/components/user-provider/UserProvider'
import { useAuthStore } from '@core/stores/auth-store'
import { toSafeRedirect } from '@core/utils/to-safe-redirect'
import { ROUTES } from '@discover/utils/router/paths'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

function AuthenticatedLayout() {
  return (
    <UserProvider>
      <Outlet />
    </UserProvider>
  )
}

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context: { queryClient }, location }) => {
    if (!useAuthStore.getState().isLogged()) {
      throw redirect({
        to: ROUTES.signIn,
        search: { redirect: toSafeRedirect(location.href) },
      })
    }

    await queryClient.ensureQueryData({
      ...getAuthSelfQueryOptions(),
      retry: queryClient.getDefaultOptions().queries?.retry,
    })
  },
  component: AuthenticatedLayout,
})
